module.exports = __webpack_public_path__ + "img/cpr.06c0da47.jpeg";